import { Toaster as Sonner, ToasterProps } from 'sonner'
import { useTheme } from '@/context/theme-provider'

export function Toaster({ ...props }: ToasterProps) {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className='toaster group z-100 pointer-events-auto [&_div[data-content]]:w-full **:data-sonner-toast:pointer-events-auto'
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          zIndex: 100,
          pointerEvents: 'auto',
        } as React.CSSProperties
      }
      {...props}
    />
  )
}
